import React from 'react';
import { Table, Placeholder } from 'semantic-ui-react';
import { ProjectsListItem } from './ProjectsListItem';
import _ from 'lodash';

export const ProjectsList = ({ projects, isLoading, role }) => {
  const showValidated = role === 'superadmin' || role === 'ksi';
  const showEdit = role !== 'user';

  // Show a placeholder table while loading projects
  const placeholderTable = _.times(10, (index) => (
    <Table.Row key={index}>
      {_.times(showValidated ? 5 : 4, (indexCell) => (
        <Table.Cell key={indexCell}>
          <Placeholder>
            <Placeholder.Line />
          </Placeholder>
        </Table.Cell>
      ))}
    </Table.Row>
  ));

  return (
    <Table celled selectable fixed singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} textAlign='center'>Suku</Table.HeaderCell>
          <Table.HeaderCell width={5}>Title</Table.HeaderCell>
          <Table.HeaderCell width={4} textAlign='center'>Munisipiu</Table.HeaderCell>
          {showValidated && (
            <Table.HeaderCell width={3} textAlign='center'>Validated</Table.HeaderCell>
          )}
          {showEdit && (
            <Table.HeaderCell width={1} textAlign='center'>Edit</Table.HeaderCell>
          )}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {isLoading
          ? placeholderTable
          : projects &&
            projects.map((project) => (
              <ProjectsListItem key={project.id} project={project} showValidated={showValidated} showEdit={showEdit} />
            ))}
      </Table.Body>
    </Table>
  );
};
